import * as types from "@/redux/types";

export const showOfflineViewHandler = () => ({ type: types.SHOW_OFFLINE_VIEW });

export const hideOfflineViewHandler = () => ({ type: types.HIDE_OFFLINE_VIEW });
